// extracted by mini-css-extract-plugin
export default {"content":"UpdateNotifier_content__jzLAa","message":"UpdateNotifier_message__-4sBn","action":"UpdateNotifier_action__+Ddt8"};